import React from 'react'
import { MVPButton } from '../../Buttons/MVPButton'
import './SettingsModal.scss'

export interface SettingsModalViewProps
{
	clickSelectDeck: () => void
}
export const SettingsModalView : React.FC<SettingsModalViewProps> = ({ clickSelectDeck }) =>
{
	return (
		<>
			<span className='modal-title-l'>Settings</span>
			<div className='modal-button-group'>
				<MVPButton className='clear' onClick={clickSelectDeck}>
					Choose Deck
				</MVPButton>
				<MVPButton className='clear' href='https://mvppoker.com/faq.html'>
					Help &amp; FAQ
				</MVPButton>
				<MVPButton className='clear' href='https://mvppoker.com/terms.html'>
					Privacy Policy
				</MVPButton>
				<MVPButton className='clear' href='https://mvppoker.com/terms.html'>
					Rules &amp; Terms
				</MVPButton>
				<MVPButton className='clear' href='https://mvppoker.com/about.html'>
					About Us
				</MVPButton>
			</div>
		</>
	)
}